export default "__VITE_ASSET__Bv0pa_ZN__"